import { RouteObject } from "react-router-dom";

export const ProtectedRoutes: RouteObject[] = [{ path: "/feed" }];
